import { colors } from '@insurancemenu/imenu-components-lib';
import ActionTile from 'components/common/proposal/ActionTile';
import styled from 'styled-components';
import { breakpointsMQ4 } from '@insurancemenu/imenu-components-lib/dist/utils/breakpoints';

export const WrapperStyled = styled.section`
  background-color: ${colors.neutral.white};
  padding: 5rem 10rem 10rem;
  border-radius: 10px;
  position: relative;
  min-height: 43rem;
  box-sizing: border-box;

  ${breakpointsMQ4.lg.down} {
    padding: 4rem 4rem 8rem;
  }
`;

export const TitleStyled = styled.h3`
  color: ${colors.neutral[900]};
  font-size: 2rem;
  line-height: 2.8rem;
  margin: 0 0 3rem;
  padding-bottom: 3rem;
  border-bottom: 1px solid ${colors.neutral[300]};
`;

export const ActionListStyled = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  justify-content: flex-start;
  gap: 3rem;

  ${breakpointsMQ4.sm.down} {
    flex-wrap: wrap;
  }
`;

export const ActionTileStyled = styled(ActionTile)`
  ${breakpointsMQ4.md.down} {
    flex-basis: 100%;
  }
`;
